import { useEffect, useMemo, useState } from 'react'
import { readPref, writePref } from '@/lib/storage'
import { ThemeContext } from './theme-context'

const KEY = 'om-theme' // also read by the inline script in index.html (no flash on load)
const query = () => window.matchMedia('(prefers-color-scheme: dark)')

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => readPref(KEY, 'system'))
  const [systemDark, setSystemDark] = useState(() => query().matches)

  useEffect(() => {
    const mq = query()
    const onChange = (e) => setSystemDark(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const resolvedTheme = theme === 'system' ? (systemDark ? 'dark' : 'light') : theme

  useEffect(() => {
    document.documentElement.classList.toggle('dark', resolvedTheme === 'dark')
    document.documentElement.style.colorScheme = resolvedTheme
  }, [resolvedTheme])

  const value = useMemo(
    () => ({
      theme,
      resolvedTheme,
      setTheme: (next) => {
        writePref(KEY, next)
        setThemeState(next)
      },
    }),
    [theme, resolvedTheme],
  )
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
